module.exports = __webpack_public_path__ + "img/vip-banner-bg.0183078b.jpg";